import { useEffect } from 'react';

import { Alert } from '@ui';

import { useNavigate } from 'react-router';
import { GoogleLoginButton, useAuthStore } from '~/auth';

import type { Route } from './+types/login';

export const meta: Route.MetaFunction = () => [{ title: 'Sign in' }];

export default function LoginRoute() {
  const navigate = useNavigate();
  const isAuthenticated = useAuthStore(state => state.isAuthenticated);
  const isRestoringSession = useAuthStore(state => state.isRestoringSession);
  const authError = useAuthStore(state => state.authError);

  useEffect(() => {
    if (isAuthenticated) navigate('/', { replace: true });
  }, [isAuthenticated, navigate]);

  return (
    <main className="min-h-screen flex items-center justify-center px-6 py-12 bg-background relative overflow-hidden">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_30%,theme(colors.teal.500/10%),transparent_60%)] pointer-events-none" />
      <div className="relative w-full max-w-sm">
        <div className="rounded-lg border border-border bg-card p-6 lg:p-8 shadow-sm space-y-5">
          <h1 className="text-lg font-semibold">Meme Generator Admin</h1>
          {isRestoringSession ? (
            <p className="text-sm text-muted-foreground">Checking session…</p>
          ) : (
            <div className="flex justify-center">
              <GoogleLoginButton />
            </div>
          )}
          {authError ? (
            <Alert variant="destructive" className="text-sm py-2.5">
              {authError}
            </Alert>
          ) : null}
        </div>
      </div>
    </main>
  );
}
